// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfo_a bhn_wj bhn_ss bhn_xl"};